<template>
    <div>
        <h3>{{title}}</h3>
        <hr />
        <div class="row">
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'bankName' + _uid">{{ $t('bankAccount.bankName') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="bankAccount.bankName"
                       :name="'bankName' + _uid"
                       :id="'bankName' + _uid">
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'bic' + _uid">{{ $t('bankAccount.bic') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="bankAccount.bic"
                       :name="'bic' + _uid"
                       :id="'bic' + _uid">
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'iban' + _uid">{{ $t('bankAccount.iban') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="bankAccount.iban"
                       :name="'iban' + _uid"
                       :id="'iban' + _uid">
            </div>

            <div class="form-group col-md-12">
                <label class="font-weight-bold" :for="'description' + _uid">{{ $t('bankAccount.description') }}</label>
                <textarea rows="3" class="form-control" v-model="bankAccount.description" :id="'description' + _uid" readonly></textarea>
            </div>
        </div>
    </div>
</template>

<script>
    import { BankAccount } from './../../models/models';

    export default {
        inject: ['$validator'],
        props: {
            bankAccount: BankAccount,
            title: String
        },
        components: {
            
        },
        data() {
            return {

            };
        },
        mounted: function () {
            this.bankAccount.uid = 'contract' + this._uid;
        },
        computed: {
            
        },
        methods: {
            
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
